import { useApi } from "@utils/useApi";
import { OrderAdditionalDetailsClient } from "@lib/ShiOneClient";
import { useQuery } from "@tanstack/react-query";
import { OrdersQueryKeys } from "@features/orders-features/hooks/OrdersQueryKeys";
import ms from "ms";

export function useGetOrderLineRelatedData(biOrderId: number | undefined) {
  const api = useApi(OrderAdditionalDetailsClient);
  const fetch = async () => {
    if (!biOrderId) return null;
    return await api.getOrderLineRelatedDataByBiOrderId(biOrderId);
  };
  return useQuery({
    queryKey: [OrdersQueryKeys.OrderLineRelatedData, biOrderId],
    queryFn: fetch,
    enabled: !!biOrderId,
    staleTime: ms("1m"),
    retry: false,
  });
}
